import classcat from "classcat";
import React from "react";
import { useTranslation } from "react-i18next";

import { TranslationContext } from "@is/constants";

import css from "./BestMatches.module.css";

export const NoBestMatches = () => {
  const { t } = useTranslation(TranslationContext.ProductListing);

  return (
    <div>
      <div className={css.additionalTitleSpacing}>
        <h1 className={classcat(["text-headline-5xl", css.noMatchingTitle])}>
          {t("No Matching Items Found")}
        </h1>
        <span className="text-label-2xl">
          {t("Adjust your search terms or check out alternatives below.")}
        </span>
      </div>
      <div className={css.showMoreContainerNoPaddings} />
    </div>
  );
};
